@if (authorized) {
<section class="spatial-shell">
      @if (showDebugInformation) {
      <div class="connection-toolbar">
        <button type="button" class="primary-action" (click)="reconnect()">
          <ion-icon name="refresh-outline"></ion-icon>
          Connetti / Riconnetti
        </button>

        <button type="button" class="secondary-action" (click)="clearLocalLog()">
          <ion-icon name="trash-outline"></ion-icon>
          Pulisci log
        </button>
      </div>

      <div class="status-grid">
        <article class="status-card">
          <div class="status-card__header">
            <span>REST config</span>
            <span class="status-badge" [ngClass]="'status-badge--' + configState">
              @if (configState === 'loading') { <ion-spinner name="dots"></ion-spinner> }
              {{ configLabel }}
            </span>
          </div>
          <strong>{{ configMessage }}</strong>
          @if (restError) { <p class="error-copy">{{ restError }}</p> }
        </article>

        <article class="status-card">
          <div class="status-card__header">
            <span>WebSocket</span>
            <span class="status-badge" [ngClass]="'status-badge--' + connectionState">{{ connectionLabel }}</span>
          </div>
          <strong>{{ connectionMessage }}</strong>
          @if (websocketError) { <p class="error-copy">{{ websocketError }}</p> }
        </article>
      </div>

      <div class="metrics-grid">
        <article class="metric-card">
          <span>Installation ID</span>
          <strong>{{ activeInstallationId || '--' }}</strong>
        </article>
        <article class="metric-card">
          <span>Calibration set</span>
          <strong>{{ calibrationSetId }}</strong>
        </article>
        <article class="metric-card">
          <span>Messaggi spatial</span>
          <strong>{{ totalMessages }}</strong>
        </article>
        <article class="metric-card">
          <span>Ultimo snapshot</span>
          <strong>{{ formatTimestamp(lastSnapshotTimestampUtcMs) }}</strong>
        </article>
        <article class="metric-card metric-card--people">
          <span>Persone correnti</span>
          <strong>{{ currentPeople.length }}</strong>
        </article>
      </div>
      }

      <div class="content-grid" [class.content-grid--map-only]="!showDebugInformation">
        <aside class="panel rooms-panel">
          <div class="panel__header rooms-panel__header">
            <div>
              <span class="panel__eyebrow">Panoramica ambienti</span>
              <h2><ion-icon name="business-outline"></ion-icon> Ambienti dell’unità</h2>
            </div>
            <span class="room-count">{{ roomCount }}</span>
          </div>

          @if (roomCount) {
            <div class="rooms-directory">
              @for (unit of unitsWithSensors; track unit.id || $index) {
                @if (unit.rooms?.length) {
                  <section class="room-unit-group">
                    <div class="room-unit-title">{{ unit.name }}</div>
                    <div class="room-directory-list">
                      @for (room of unit.rooms; track room.id || $index) {
                        <button
                          type="button"
                          class="room-directory-card"
                          [class.is-alert]="room.alert"
                          [class.is-offline]="room.offlineMode === 'full'"
                          [style.border-color]="room.alert ? eventTypeToData[room.alert.eventType].exaColor : null"
                          (click)="selectRoom(room)"
                          [attr.aria-label]="'Apri dettagli stanza ' + room.name">
                          <span class="spatial-room-header">
                            <strong class="spatial-room-name" [class.text-offline]="room.offlineMode === 'full'">
                              {{ room.name }}
                            </strong>
                            <span class="spatial-room-indicators">
                              @if (room.bedExitDelayMinutes) {
                                <span class="spatial-room-indicator delay-indicator"
                                  [attr.title]="'Ritardo uscita letto: ' + room.bedExitDelayMinutes + ' minuti'">
                                  <mat-icon svgIcon="bed_exit_delay_clock"></mat-icon>
                                  <small>{{ room.bedExitDelayMinutes }}</small>
                                </span>
                              }
                              @if (room.notificationSilencedList?.status !== 'active' && room.notificationSilencedList?.status) {
                                <span class="spatial-room-indicator silenced-indicator"
                                  [class.partially-silenced-indicator]="room.notificationSilencedList?.status === 'partial'"
                                  [attr.title]="room.notificationSilencedList?.status === 'partial'
                                    ? 'Alcune notifiche sono disattivate'
                                    : 'Tutte le notifiche sono disattivate'">
                                  <mat-icon>notifications</mat-icon>
                                </span>
                              }
                            </span>
                          </span>

                          <span class="spatial-room-body">
                            @if (showBedStates) {
                              <app-bed-states-room [roomId]="room.id || ''" [unitId]="unit.id || ''"></app-bed-states-room>
                            } @else if (room.alert) {
                              <mat-icon [svgIcon]="eventTypeToData[room.alert.eventType].svgIcon"
                                class="spatial-room-main-icon alert-icon"
                                [style.color]="eventTypeToData[room.alert.eventType].exaColor">
                              </mat-icon>
                            } @else if (room.offlineMode) {
                              <mat-icon [svgIcon]="eventTypeToData['06'].svgIcon"
                                class="spatial-room-main-icon offline-icon"></mat-icon>
                            } @else {
                              <span class="spatial-bed-icon-wrapper">
                                <mat-icon svgIcon="bed" class="spatial-room-main-icon bed-icon"></mat-icon>
                                @if (room.beds?.length) {
                                  <span class="bed-count-pill">{{ room.beds?.length }}</span>
                                }
                              </span>
                            }
                          </span>

                          <span class="spatial-room-footer">
                            @if (room.alert) {
                              <span class="spatial-info-chip alert-chip"
                                [style.background-color]="eventTypeToData[room.alert.eventType].exaColor + '15'"
                                [style.color]="eventTypeToData[room.alert.eventType].exaColor">
                                <span>{{ eventTypeToData[room.alert.eventType].translation | translate }}</span>
                                <span>&middot;</span>
                                <span>{{ getTimeLeft(room.alert.timestamp) }}m</span>
                              </span>
                            } @else if (room.offlineMode === 'full') {
                              <span class="spatial-info-chip offline-chip">OFFLINE</span>
                            } @else {
                              <span class="spatial-room-metadata">
                                {{ room.beds?.length || 0 }} letti &middot; {{ room.devices?.length || 0 }} sensori
                              </span>
                            }
                          </span>
                        </button>
                      }
                    </div>
                  </section>
                }
              }
            </div>
          } @else {
            <div class="rooms-empty-state">
              <ion-icon name="business-outline"></ion-icon>
              <strong>Nessuna stanza censita</strong>
              <span>Le stanze della struttura compariranno qui.</span>
            </div>
          }
        </aside>

        <article class="panel map-panel">
          <div class="panel__header">
            <div>
              <span class="panel__eyebrow">Visualizzazione</span>
              <h2><ion-icon name="map-outline"></ion-icon> Mappa unità</h2>
            </div>
            <div class="map-header-actions">
              <div class="display-switches">
                <label class="display-switch">
                  <input type="checkbox" [(ngModel)]="showDebugInformation">
                  <span class="display-switch__control" aria-hidden="true"></span>
                  <span>Info diagnostiche</span>
                </label>
                <label class="display-switch">
                  <input type="checkbox" [(ngModel)]="showMarkerDetails">
                  <span class="display-switch__control" aria-hidden="true"></span>
                  <span>Dettagli marker</span>
                </label>
              </div>
              <div class="zoom-controls" aria-label="Controlli zoom mappa">
                <button type="button" (click)="zoomOut()" [disabled]="mapZoom <= mapZoomMin"
                  aria-label="Riduci zoom">−</button>
                <button type="button" class="zoom-level" (click)="resetMapZoom()"
                  title="Ripristina zoom">{{ mapZoomPercent }}%</button>
                <button type="button" (click)="zoomIn()" [disabled]="mapZoom >= mapZoomMax"
                  aria-label="Aumenta zoom">+</button>
              </div>
              <span class="pan-hint">Trascina la mappa per spostarti</span>
              @if (showDebugInformation) {
            <div class="map-badges">
              @if (config?.map?.map_id) { <span class="map-id">{{ config?.map?.map_id }}</span> }
            </div>
              }
            </div>
          </div>

          @if (mapImageUrl; as imageUrl) {
            <div class="stream-notice" role="status">{{ streamMessage }}</div>
            <div #mapStage
              class="map-stage"
              [style.--map-aspect-ratio]="mapAspectRatio"
              [style.--map-zoom]="mapZoom"
              [class.is-panning]="isMapPanning"
              (wheel)="onMapWheel($event)"
              (pointerdown)="startMapPan($event)"
              (pointermove)="moveMapPan($event)"
              (pointerup)="endMapPan($event)"
              (pointercancel)="endMapPan($event)">
              <div #mapZoomLayer class="map-zoom-layer">
              <img [src]="imageUrl" alt="Mappa dell'installazione" (load)="onMapImageLoad($event)" (error)="onMapImageError()">
              <div class="map-overlay">
                @for (marker of mapMarkers; track marker.person.id) {
                  <div
                    class="person-marker"
                    [class.person-marker--unknown]="marker.pose.pose === 'unknown'"
                    [attr.data-pose]="marker.pose.pose"
                    [style.left.%]="marker.leftPercent"
                    [style.top.%]="marker.topPercent"
                    [style.width.%]="marker.widthPercent"
                    role="img"
                    [attr.aria-label]="marker.description"
                    [attr.title]="marker.description">
                    <span class="person-marker__symbol" aria-hidden="true">
                      <svg viewBox="-32 -32 64 64" focusable="false" [attr.fill]="marker.pose.color"
                        [attr.stroke]="marker.pose.edge" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                        @if (marker.pose.pose === 'unknown') {
                          <circle r="10" fill="none" stroke="#ebebeb" stroke-width="2"></circle>
                          <circle r="6" stroke="#555450"></circle>
                        } @else {
                          <g [attr.transform]="'rotate(' + marker.heading + ')'">
                            <ellipse [attr.rx]="marker.pose.shadow.rx" [attr.ry]="marker.pose.shadow.ry" fill="#191814" fill-opacity=".14" stroke="none"></ellipse>
                            @for (ellipse of marker.pose.ellipses; track $index) {
                              <ellipse [attr.cx]="ellipse.cx" [attr.cy]="ellipse.cy" [attr.rx]="ellipse.rx + 2" [attr.ry]="ellipse.ry + 2" [attr.fill]="marker.pose.edge" stroke="none"></ellipse>
                              <ellipse [attr.cx]="ellipse.cx" [attr.cy]="ellipse.cy" [attr.rx]="ellipse.rx" [attr.ry]="ellipse.ry" stroke="none"></ellipse>
                            }
                            @for (limb of marker.pose.limbs; track $index) {
                              <path [attr.d]="limb.path" fill="none" [attr.stroke]="marker.pose.edge" [attr.stroke-width]="limb.width + 3"></path>
                              <path [attr.d]="limb.path" fill="none" [attr.stroke]="marker.pose.color" [attr.stroke-width]="limb.width"></path>
                            }
                            @if (marker.pose.bodyPath) { <path [attr.d]="marker.pose.bodyPath"></path> }
                            <path class="person-marker__head" [attr.d]="marker.pose.headPath"></path>
                          </g>
                        }
                      </svg>
                    </span>
                    <span class="person-marker__track" aria-hidden="true">{{ marker.person.id }}{{ marker.pose.pose === 'unknown' ? ' ?' : '' }}</span>
                    @if (showMarkerDetails) {
                    <div class="person-marker__label">
                      <strong>{{ marker.person.id }}</strong>
                      <span>{{ marker.pose.label }}{{ marker.person.state === 'held' ? ' · Ultima posa rilevata' : '' }}</span>
                      <span>Confidence {{ marker.person.confidence | percent:'1.0-0' }}</span>
                      <small>{{ marker.person.observed_by.length ? marker.person.observed_by.join(', ') : 'Nessun sensore' }}</small>
                    </div>
                    }
                  </div>
                }
              </div>
              </div>
            </div>
          } @else {
            <div class="map-placeholder">
              @if (configState === 'loading') {
                <ion-spinner name="crescent"></ion-spinner>
                <p>Caricamento asset mappa...</p>
              } @else {
                <ion-icon name="warning-outline"></ion-icon>
                <h3>{{ configMessage }}</h3>
                @if (restError) { <p>{{ restError }}</p> }
                <button type="button" class="secondary-action" (click)="reconnect()">Ricarica configurazione</button>
              }
            </div>
          }
        </article>

        @if (showDebugInformation) {
        <aside class="diagnostic-column">
          <article class="panel people-panel">
            <div class="panel__header">
              <div>
                <span class="panel__eyebrow">Snapshot corrente</span>
                <h2><ion-icon name="people-outline"></ion-icon> Persone</h2>
              </div>
              <span class="people-count">{{ currentPeople.length }}</span>
            </div>

            @if (currentPeople.length) {
              <div class="people-list">
                @for (person of currentPeople; track person.id) {
                  <div class="person-row">
                    <strong>{{ person.id }}</strong>
                    <span>{{ person.confidence | percent:'1.0-0' }}</span>
                    <small>x {{ person.x_m | number:'1.2-2' }} m · z {{ person.z_m | number:'1.2-2' }} m</small>
                  </div>
                }
              </div>
            } @else {
              <p class="empty-copy">Nessuna persona nello snapshot corrente. Un array <code>people: []</code> è uno stato valido.</p>
            }
          </article>

          <details class="panel json-panel">
            <summary>Ultimo payload JSON</summary>
            <pre>{{ lastPayloadJson }}</pre>
          </details>

          <details class="panel log-panel">
            <summary>Log locale ({{ messageLog.length }}/50)</summary>
            @if (messageLog.length) {
              <div class="log-list">
                @for (entry of messageLog; track $index) {
                  <div class="log-entry">
                    <span>{{ entry.receivedAt | date:'HH:mm:ss' }}</span>
                    <code>{{ entry.payload.type }}</code>
                  </div>
                }
              </div>
            } @else {
              <p class="empty-copy">Il log locale è vuoto.</p>
            }
          </details>
        </aside>
        }
      </div>
</section>
}
